import { render, staticRenderFns } from "./EditPatient.vue?vue&type=template&id=16ce0ab0&"
import script from "./EditPatient.vue?vue&type=script&lang=js&"
export * from "./EditPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports